import React, { useState } from "react";

const TwoFactorForm = ({ onSubmit, onBackToLogin, logoURL, clientDescription, message, setMessage, isMobile }) => {
  const [code, setCode] = useState("");

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setMessage("");
    onSubmit(code); // only send the code back to LoginPage
  };

  const isSuccess = message && (message.toLowerCase().includes("success") || message.toLowerCase().includes("ok"));

  return (
    <div className="inner-form-container">
      <h2>{clientDescription}</h2>
      <img
        src={logoURL ? `${logoURL}` : "https://placehold.co/250x250/png"}
        alt="Brand Logo"
        className="branding-image"
      />
      <h2>Two Factor Authentication</h2>
      <p>
        A short two-factor authentication code has been sent to your email address. Please enter the code below to continue.
        Can't find the email? Please check your spam or junk folder.
      </p>

      {message && <div className={isSuccess ? "success-box" : "error-box"}>{message}</div>}

      <form onSubmit={handleFormSubmit} className="form">
        <label className="label">
          2FA Code:
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            className="input"
            placeholder="Enter code"
          />
        </label>

        <button type="submit" className="login-button">Verify</button>
        <button type="button" onClick={onBackToLogin} className="register-button">Back to Login</button>
      </form>
    </div>
  );
};

export default TwoFactorForm;
